export const GREEN = "#0EC22B";
//export const THEME_COLOR = '#580BE4';
//export const THEME_COLOR_LIGHT = '#A073F2';
export const THEME_COLOR = process.env.REACT_APP_THEME_COLOR;
export const THEME_COLOR_LIGHT = "#88FF7F";
